export const FETCH_UNIVERSITIES = "FETCH_UNIVERSITIES";
export const SEARCH_UNIVERSITIES = "SEARCH_UNIVERSITIES";
export const FILTER_UNIVERSITIES_BY_NAME = "FILTER_UNIVERSITIES_BY_NAME";
export const FILTER_UNIVERSITIES_BY_STATUS = "FILTER_UNIVERSITIES_BY_STATUS";
export const FILTER_UNIVERSITIES_BY_TYPE = "FILTER_UNIVERSITIES_BY_TYPE";
export const FILTER_UNIVERSITIES_BY_PROVINCE =
  "FILTER_UNIVERSITIES_BY_PROVINCE";
export const UNDO_FILTER_UNIVERSITIES_BY_NAME =
  "UNDO_FILTER_UNIVERSITIES_BY_NAME";

export const UNDO_FILTER_UNIVERSITIES_BY_TYPE =
  "UNDO_FILTER_UNIVERSITIES_BY_TYPE";

export const UNDO_FILTER_UNIVERSITIES_BY_PROVINCE =
  "UNDO_FILTER_UNIVERSITIES_BY_PROVINCE";

export const NOTFOUND = "NOTFOUND";
export const FOUND = "FOUND";
export const LOADING = "LOADING";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
